





























































































































































































































































































import Vue from 'vue';
import { AxiosResponse } from 'axios';
import {
  Component, Inject, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, Dialog } from '@kasasa/fbase-components/lib';
import CycleSetDialog from '@/components/CycleSetDialog.vue';
import CycleDialog from '@/components/CycleDialog.vue';
import GapWarning from '@/components/gapwarning/GapWarning.vue';
import { GapWarningInfo, IGapWarningConfig } from '@/api/gapwarning';

import {
  Cycle,
  CycleSet,
  CycleResource,
} from '@/api/cycles';
import { ProcessingDays, ProcessingDaysResource } from '@/api/processingdays';

@Component({
  computed: mapState(['fiId']),
  components: {
    'cycle-set-dialog': CycleSetDialog,
    'cycle-dialog': CycleDialog,
    'gap-warning': GapWarning,
  },
})
export default class CycleSets extends Vue {
  @Inject('CycleResource')
  cycleResource!: CycleResource;

  @Inject('ProcessingDaysResource')
  processingDaysResource!: ProcessingDaysResource;

  fiId!: string;

  loading: boolean = false;

  cycleSets: CycleSet[] = [];

  selectedCycleSet: CycleSet|null = null;

  currentCyclesInSelectedCycleSet: Cycle[] = [];

  pastCyclesInSelectedCycleSet: Cycle[] = [];

  static ALL_STATEMENT_CODE = 'All Statement Cycle Codes';

  warnings: IGapWarningConfig[] = [];

  hasProcessingDays: boolean = false;

  cycleSetsHeaders:DataTableHeader[] = [
    { text: '', value: 'edit', sortable: false },
    { text: 'Cycle Set Name', value: 'name', sortable: false },
    { text: 'Statement Cycle Codes', value: 'statementCycleCodes', sortable: false },
    { text: '', value: 'deleteIcon', sortable: false },
  ];

  cycleHeader:DataTableHeader[] = [
    { text: '', value: 'edit', sortable: false },
    { text: 'Drop Date', value: 'dropDate', sortable: false },
    { text: '2nd Drop Date', value: 'secondDropDate', sortable: false },
    { text: 'Start', value: 'statementStartDate', sortable: false },
    { text: 'End', value: 'statementEndDate', sortable: false },
    { text: 'Start', value: 'qualificationStartDate', sortable: false },
    { text: 'End', value: 'qualificationEndDate', sortable: false },
    { text: 'Start', value: 'earningsStartDate', sortable: false },
    { text: 'End', value: 'earningsEndDate', sortable: false },
    { text: '', value: 'trashIcon', sortable: false },
  ];

  footerProps = {
    'items-per-page-options': [{ value: -1, text: 'All' }, 25, 50, 100],
  }

  cycleSetsHeaderItems: any = [
    {
      text: 'Rewards Configuration',
      disabled: true,
      link: false,
    },
    {
      text: 'Cycle Sets',
      disabled: true,
      link: false,
    },
  ];

  cycleHeaderItems: any = [
    {
      text: 'Rewards Configuration',
      disabled: true,
      link: false,
    },
    {
      text: 'Cycle Sets',
      disabled: false,
      link: true,
    },
    {
      text: 'Cycle',
      disabled: true,
      link: false,
    },
  ];

  mounted() {
    this.loading = true;
    this.processingDaysResource.getAll(Number(this.fiId))
      .then((result:ProcessingDays) => {
        if (result === null || result === undefined || result.normalProcessingDays === undefined || result.normalProcessingDays.length < 4) {
          this.hasProcessingDays = false;
          this.loading = false;
          this.setError('Processing Days must be configured before configuring Cycle Sets.');
        } else {
          this.hasProcessingDays = true;
          this.cycleResource.getAllCycleSets(this.fiId)
            .then((result1:CycleSet[]) => {
              this.cycleSets = result1;
              this.loading = false;
            })
            .catch((error:any) => {
              if (this.hasProcessingDays) {
                this.showError(error);
              }
              this.loading = false;
            });
        }
      })
      .catch((error:any) => {
        this.setError('Processing Days must be configured before configuring Cycle Sets.');
        this.hasProcessingDays = false;
        this.loading = false;
      });
  }

  getLastCurrentCycle() {
    return this.currentCyclesInSelectedCycleSet[this.currentCyclesInSelectedCycleSet.length - 1];
  }

  viewSelectedCycleSet(cycleSet: CycleSet) {
    this.currentCyclesInSelectedCycleSet = this.getCurrentCycles(cycleSet.cyclesDesc);
    this.pastCyclesInSelectedCycleSet = this.getPastCycles(cycleSet.cyclesDesc);
    this.selectedCycleSet = cycleSet;
  }

  viewAllCycleSets() {
    this.currentCyclesInSelectedCycleSet = [];
    this.pastCyclesInSelectedCycleSet = [];
    this.selectedCycleSet = null;
  }

  goTo(breadcrumbItem: string) {
    if (breadcrumbItem === 'Cycle Sets') {
      this.viewAllCycleSets();
    }
  }

  updateCurrentAndPastCycles() {
    this.currentCyclesInSelectedCycleSet = this.getCurrentCycles(this.selectedCycleSet!.cyclesDesc);
    this.pastCyclesInSelectedCycleSet = this.getPastCycles(this.selectedCycleSet!.cyclesDesc);
  }

  onDeleteCyclesSet(cycleSet: CycleSet) {
    const dialog = new Dialog('Confirm Deletion',
      'Are you sure you want to delete this cycle set and all associated cycles?');
    dialog.setAcceptLabel('OK')
      .setDeclineLabel('Cancel');
    this.$store.dispatch('notices/add', dialog)
      .then((ok) => {
        if (ok === 'accept') {
          this.cycleResource.removeCycleSet(this.fiId, cycleSet.id!)
            .then((result:AxiosResponse) => {
              this.removeCycleSetFromList(cycleSet);
            });
        }
      })
      .catch((error:any) => {
        if (error && error.response && error.response.status === 422) {
          this.setError('CycleSet cannot be deleted because it has associated Account Results');
        } else {
          this.setError('Unexpected error in deleting CycleSet');
        }
      });
  }

  removeCycleSetFromList(cycleSet: CycleSet) {
    for (let i:number = 0; i < this.cycleSets.length; i++) {
      if (this.cycleSets[i].id === cycleSet.id) {
        this.cycleSets.splice(i, 1);
        break;
      }
    }
    this.showSuccess(`Deleted Cycle Set: ${cycleSet.name}`);
  }

  onDeleteCycle(cycle: Cycle) {
    const dialog = new Dialog('Confirm Deletion',
      'Are you sure you want to delete this cycle?');
    dialog.setAcceptLabel('OK')
      .setDeclineLabel('Cancel');
    this.$store.dispatch('notices/add', dialog)
      .then((ok) => {
        if (ok === 'accept') {
          this.cycleResource.removeCycle(this.fiId, cycle.id!)
            .then((result:AxiosResponse) => {
              this.removeCycleFromList(cycle);
            });
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.status === 422) {
          this.setError('Cycle cannot be deleted because it has associated Account Results');
        } else {
          this.setError('Unexpected error in deleting Cycle');
        }
      });
  }

  removeCycleFromList(cycle: Cycle) {
    for (let i:number = 0; i < this.selectedCycleSet!.cyclesDesc.length; i++) {
      if (this.selectedCycleSet!.cyclesDesc[i].id === cycle.id) {
        this.selectedCycleSet!.cyclesDesc.splice(i, 1);
        break;
      }
    }

    this.currentCyclesInSelectedCycleSet = this.getCurrentCycles(this.selectedCycleSet!.cyclesDesc);
    this.showSuccess(`Deleted Cycle with drop date: ${
      this.getFriendlyFormattedDate(cycle.dropDate)}`);
  }

  onCyclesSetSaved(savedCycleSet: CycleSet) {
    let found:boolean = false;
    for (let i:number = 0; i < this.cycleSets.length; i++) {
      if (this.cycleSets[i].id === savedCycleSet.id) {
        // Saved an existing cycle set, so make sure that it is up to date.
        Object.assign(this.cycleSets[i], savedCycleSet);
        found = true;
        break;
      }
    }
    if (!found) {
      const cycleSet = savedCycleSet;
      this.cycleSets.push(cycleSet);
    }
    this.showSuccess(`Saved Cycle Set: ${savedCycleSet.name}`);
  }

  onCycleSaved(savedCycle: Cycle) {
    let found:boolean = false;
    for (let j:number = 0; j < this.selectedCycleSet!.cyclesDesc.length; j++) {
      if (this.selectedCycleSet!.cyclesDesc[j].id === savedCycle.id) {
        // Saved an existing cycle, so make sure that it is up to date.
        Object.assign(this.selectedCycleSet!.cyclesDesc[j], savedCycle);
        found = true;
        break;
      }
    }
    if (!found) {
      const cycle = savedCycle;
      this.selectedCycleSet!.cyclesDesc.push(cycle);
    }

    this.updateCurrentAndPastCycles();
    this.showSuccess(`Saved Cycle with drop date: ${
      this.getFriendlyFormattedDate(savedCycle.dropDate)}`);
  }

  getCycleCodes = (cycleSet: CycleSet) => {
    const cycleCodes:string[] = [];
    Object.assign(cycleCodes, cycleSet.statementCycleCodes);
    if (cycleSet.processAllStatementCycleCodes) {
      return CycleSets.ALL_STATEMENT_CODE;
    }
    return cycleCodes.sort().join('; ');
  }

  getFriendlyFormattedDate = (date: string) => {
    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`;
  }

  getCurrentCycles(cycles: Cycle[]) {
    const currentCycles: Cycle[] = [];
    const today = this.todayDate();
    cycles.forEach((cycle) => {
      if (this.parseDate(cycle.secondDropDate) >= today) {
        currentCycles.push(cycle);
      }
    });
    this.checkForGaps(currentCycles);
    return this.sortCyclesByDropDate(currentCycles).reverse();
  }

  getPastCycles(cycles: Cycle[]) {
    const filteredCycles: Cycle[] = [];
    const today = this.todayDate();
    cycles.forEach((cycle) => {
      if (this.parseDate(cycle.secondDropDate) < today) {
        filteredCycles.push(cycle);
      }
    });
    return this.sortCyclesByDropDate(filteredCycles);
  }

  sortCyclesByDropDate = (cycles: Cycle[]) => cycles.sort((a, b) => new Date(b.dropDate).valueOf() - new Date(a.dropDate).valueOf())

  checkForGaps(currentCycles: Cycle[]) {
    this.warnings = [];
    if (currentCycles.length < 1) {
      return;
    }

    // Sort by statement date.  We will re-sort before each check, as it's possible (however unlikely)
    // that different values of statement/qualification/earnings start dates could result
    // in different orderings.
    currentCycles.sort((cycle1, cycle2) => new Date(cycle1.statementStartDate).getTime() - new Date(cycle2.statementStartDate).getTime());
    for (let i = 1; i < currentCycles.length; i++) {
      this.checkForGapBeforeStatementStart(currentCycles[i - 1], currentCycles[i]);
    }

    currentCycles.sort((cycle1, cycle2) => new Date(cycle1.qualificationStartDate).getTime() - new Date(cycle2.qualificationStartDate).getTime());
    for (let i = 1; i < currentCycles.length; i++) {
      this.checkForGapBeforeQualificationStart(currentCycles[i - 1], currentCycles[i]);
    }

    currentCycles.sort((cycle1, cycle2) => new Date(cycle1.earningsStartDate).getTime() - new Date(cycle2.earningsStartDate).getTime());
    for (let i = 1; i < currentCycles.length; i++) {
      this.checkForGapBeforeEarningsStart(currentCycles[i - 1], currentCycles[i]);
    }
  }

  checkForGapBeforeStatementStart(previousCycle: Cycle, currentCycle: Cycle) {
    if (this.addOneDay(previousCycle.statementEndDate) !== currentCycle.statementStartDate) {
      this.warnings.push(new GapWarningInfo('statement', currentCycle.statementStartDate, previousCycle.statementEndDate));
    }
  }

  checkForGapBeforeQualificationStart(previousCycle: Cycle, currentCycle: Cycle) {
    if (this.addOneDay(previousCycle.qualificationEndDate) !== currentCycle.qualificationStartDate) {
      this.warnings.push(new GapWarningInfo('qualification', currentCycle.qualificationStartDate, previousCycle.qualificationEndDate));
    }
  }

  checkForGapBeforeEarningsStart(previousCycle: Cycle, currentCycle: Cycle) {
    if (this.addOneDay(previousCycle.earningsEndDate) !== currentCycle.earningsStartDate) {
      this.warnings.push(new GapWarningInfo('earnings', currentCycle.earningsStartDate, previousCycle.earningsEndDate));
    }
  }

  parseDate = (date: string) => {
    const parts = date.split('-');
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  }

  todayDate = () => {
    const daDate = new Date();
    daDate.setHours(0, 0, 0, 0);
    return daDate;
  }

  addOneDay(dateString: string) {
    const date = this.parseDate(dateString);
    date.setDate(date.getDate() + 1);
    return date.toISOString().substring(0, 10);
  }

  showError(error: any) {
    if (error.response && error.response.data && error.response.data.entity) {
      this.setError(error.response.data.entity);
    } else {
      this.setError('An unexpected error occurred.');
    }
  }

  setError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  showSuccess(message: string) {
    const al = new Alert(message, NoticeClass.SUCCESS);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
